import type {ValidatePasswordResponse} from '@rocket-ui/lk-api';
import {ROUTES} from 'app/router/routes';
import {isFullInfoComplete} from 'features/auth';

export type AuthTokenResponse = Pick<ValidatePasswordResponse, 'authToken' | 'expiresAt' | 'fullInfo'>;

export type AuthResponseSource = 'validate' | 'secret_code';

function shouldValidateFullInfo(response: AuthTokenResponse, source: AuthResponseSource): boolean {
	if (source === 'validate') {
		return true;
	}

	return response.fullInfo != null;
}

export function resolvePostAuthPath(response: AuthTokenResponse, source: AuthResponseSource): string {
	if (!shouldValidateFullInfo(response, source)) {
		return ROUTES.orders;
	}

	return isFullInfoComplete(response.fullInfo) ? ROUTES.orders : ROUTES.registration;
}
